import { createBrowserRouter, Navigate } from 'react-router';

import { Shell } from './Shell.tsx';
import { AcceptInvitePage } from '../features/auth/AcceptInvitePage.tsx';
import { ForgotPasswordPage } from '../features/auth/ForgotPasswordPage.tsx';
import { LoginPage } from '../features/auth/LoginPage.tsx';
import { ResetPasswordPage } from '../features/auth/ResetPasswordPage.tsx';
import { CandidateDetailPage } from '../features/candidates/CandidateDetailPage.tsx';
import { CandidatesPage } from '../features/candidates/CandidatesPage.tsx';
import { CompaniesPage } from '../features/companies/CompaniesPage.tsx';
import { CompanyDetailPage } from '../features/companies/CompanyDetailPage.tsx';
import { CuratorsPage } from '../features/curators/CuratorsPage.tsx';
import { DigestPreviewPage } from '../features/ops/DigestPreviewPage.tsx';
import { OpsPage } from '../features/ops/OpsPage.tsx';
import { OverviewPage } from '../features/overview/OverviewPage.tsx';
import { RoleDetailPage } from '../features/roles/RoleDetailPage.tsx';
import { RolesPage } from '../features/roles/RolesPage.tsx';
import { RankingPage } from '../features/settings/RankingPage.tsx';
import { SuggestionsPage } from '../features/taxonomy/SuggestionsPage.tsx';
import { TaxonomyPage } from '../features/taxonomy/TaxonomyPage.tsx';

export const router = createBrowserRouter([
  { path: '/login', Component: LoginPage },
  { path: '/forgot-password', Component: ForgotPasswordPage },
  { path: '/reset-password', Component: ResetPasswordPage },
  { path: '/accept-invite', Component: AcceptInvitePage },
  {
    path: '/',
    Component: Shell,
    children: [
      { index: true, Component: OverviewPage },
      { path: 'candidates', Component: CandidatesPage },
      { path: 'candidates/:id', Component: CandidateDetailPage },
      { path: 'companies', Component: CompaniesPage },
      { path: 'companies/:id', Component: CompanyDetailPage },
      { path: 'roles', Component: RolesPage },
      { path: 'roles/:id', Component: RoleDetailPage },
      { path: 'taxonomy', Component: TaxonomyPage },
      { path: 'ranking', Component: RankingPage },
      { path: 'suggestions', Component: SuggestionsPage },
      { path: 'curators', Component: CuratorsPage },
      { path: 'ops', Component: OpsPage },
      { path: 'ops/digest-preview', Component: DigestPreviewPage },
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
